import { Module } from 'vuex';
import { OrderPaymentState } from './types';
import { RootState } from '@/store/types';
import { getters } from '@/store/modules/orders/getters';
import { actions } from '@/store/modules/orders/actions';
import { mutations } from '@/store/modules/orders/mutations';

export const state: OrderPaymentState = {
  status: {
    error: null,
    message: null
  },
  feedbackStatistics: null,
  feedbackStatisticsWeek: null,
  dailyStatistics: null,
  feedbackReport: null
};

export const orders: Module<OrderPaymentState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
